import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { NonUsfProductSortOptions } from '@usf/ngrx-product';

@Component({
  selector: 'app-non-usf-product-sort-header',
  templateUrl: './non-usf-product-sort-header.component.html',
  styleUrls: ['./non-usf-product-sort-header.component.scss'],
})
export class NonUsfProductSortHeaderComponent {
  @Input() platform: PlatformEnum;
  @Input() sortOptions: NonUsfProductSortOptions;

  @Output() sortClickEmitter: EventEmitter<string> = new EventEmitter();

  platformEnum = PlatformEnum;

  constructor() {}

  handleSortClick(headerName: string) {
    this.sortClickEmitter.emit(headerName);
  }
}
